import React from 'react';
import LoaderSVG from './LoaderSVG';
import NoDataFound from './NoDataFound';

const ListView = ({ 
  data = [], 
  loading, 
  renderHeader, 
  renderRow,
  noDataMessage = "No records found", 
  noDataSubMessage = "Try adjusting your filters"
}) => {
  // Loading state
  if (loading) {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 rounded-lg shadow-sm text-sm">
          {renderHeader && (
            <thead className="bg-gray-100">
              <tr>{renderHeader()}</tr>
            </thead>
          )}
          <tbody>
            <tr aria-label="Loading items">
              <td 
                colSpan={React.Children.count(renderHeader())} 
                className="px-4 py-16 text-center border border-gray-200"
              >
                <LoaderSVG />
                <p className="mt-2 text-gray-500 text-sm">Loading data...</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  // Empty state
  if (!data || data.length === 0) {
    return <NoDataFound message={noDataMessage} subMessage={noDataSubMessage} />;
  }

  // Data table
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-200 rounded-lg shadow-md text-sm">
        {renderHeader && (
          <thead className="bg-gray-100">
            <tr className="text-left">{renderHeader()}</tr>
          </thead>
        )}
        <tbody className="divide-y divide-gray-200">
          {data.map((item, index) => (
            <tr 
              key={item.id || index} 
              className="hover:bg-gray-50 transition-colors duration-150"
            >
              {renderRow(item, index)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListView;
